<div id="validate-id-fetch-modal-container-{{ componentId }}" class="w-100">
  <irembogov-generic-data-fetch
    [formControl]="formControl"
    [id]="field.key"
    class="w-100"
    [genericInputLength]="field.props['genericInputLength']"
    [inputLenghtAsMinLength]="field.props['inputLenghtAsMinLength'] ?? false"
    [inputLenghtAsMaxLength]="field.props['inputLenghtAsMaxLength'] ?? false"
    [placeholder]="field.props['placeholder']"
    [statusClass]="statusClass"
    [triggerType]="field.props['triggerType']"
    [disableInternalFormControl]="field.props['disableInternalFormControl']"
    [preserveFetchingStatus]="true"
    [numericOnly]="field.props['numericOnly']"
    [successMsg]="field.props['successMessage']"
    (dataFetch)="onDataFetch($event)"></irembogov-generic-data-fetch>
</div>

<irembogov-nid-verification
  #nidVerification
  [modalContainerId]="'validate-id-fetch-modal-container-' + componentId">
</irembogov-nid-verification>

<ng-template #dppVerificationModal let-modal>
  <div class="modal-header border-bottom-0 pb-0 p-3">
    <span
      class="modal-title d-flex align-items-center justify-content-center text-warning"
      style="font-size: 24px">
      <i class="icon-alert-triangle"></i>
    </span>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body p-3">
    <div class="mb-3">
      <h4 class="mb-2">
        {{ dppConfig?.modalTitle || 'Data Privacy Protection' | translate }}
      </h4>
      <p class="text-muted">
        {{ dppConfig?.promptMessage || '' | translate }}
      </p>
    </div>
    <div class="input-group mb-3 d-flex flex-column">
      <label class="mb-1 w-100 fw-bold">
        {{ dppConfig?.inputLabel || 'Verification Value' | translate }}
      </label>
      <input
        type="text"
        class="form-control w-100"
        [placeholder]="dppConfig?.inputPlaceholder || 'Enter value' | translate"
        [formControl]="dppInputControl"
        (keyup.enter)="executeDPPVerifyRequest(modal)"
        [readonly]="isVerifyingDPP" />
      <small class="w-100 text-danger mt-1" *ngIf="dppError">
        {{ dppError | translate }}
      </small>
    </div>
  </div>
  <div
    class="modal-footer d-flex justify-content-between border-top-0 pt-0 w-100 p-3">
    <button
      type="button"
      class="btn btn-outline-dark flex-grow-1"
      (click)="modal.dismiss('cancel')"
      [disabled]="isVerifyingDPP">
      {{ 'Cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary flex-grow-1"
      (click)="executeDPPVerifyRequest(modal)"
      [disabled]="dppInputControl.invalid || isVerifyingDPP">
      <div
        *ngIf="isVerifyingDPP"
        class="spinner-border spinner-border-sm text-light me-2"></div>
      {{ 'Verify' | translate }}
    </button>
  </div>
</ng-template>
